var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTracxn = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "M0 11.572c.035-.137.07-.262.08-.386a11.9 11.9 0 0 1 2.335-6.09 11.7 11.7 0 0 1 3.66-3.271 12.004 12.004 0 0 1 9.622-.996 11.9 11.9 0 0 1 4.274 2.45 12.2 12.2 0 0 1 2.925 3.96 11.987 11.987 0 0 1 .201 9.585 12.2 12.2 0 0 1-2.757 4.075 12 12 0 0 1-5.778 3.067c-.532.114-1.086.159-1.641.239l-.231.045h-1.295l-.23-.045a12.1 12.1 0 0 1-4.687-1.347 11.9 11.9 0 0 1-3.75-3.073A11.97 11.97 0 0 1 .091 13.31a3 3 0 0 0-.08-.386V11.56zm12.678-.148.023.193.312 3.113c.081.818.174 1.636.231 2.454.018.374.116.74.287 1.075s.412.63.707.867a3.418 3.418 0 0 0 4.033.17c.419-.263.752-.638.963-1.08s.29-.934.228-1.419l-.116-.954q-.436-4.418-.855-8.838a2.52 2.52 0 0 0-.659-1.477 7 7 0 0 0-.531-.534 2.56 2.56 0 0 0-1.267-.677c-.48-.1-.979-.063-1.437.109l-.486.148-5.593 1.658-3.525 1.023a2.9 2.9 0 0 0-1.168.681 3.36 3.36 0 0 0-.97 2.28c-.019.854.29 1.683.866 2.321.694.705 1.503 1 2.485.807.254-.057.509-.148.763-.227l5.385-1.59.324-.114z"
  })));
};
export default SvgTracxn;